"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {on, findAllIn, find, findIn, closest} from "@elements/dom-utils";
import Tab from 'bootstrap/js/dist/tab';

const selectors = {
    base: '.js-activate-tab',
    nav: '.js-activate-tab__nav'
};

export function init() {
    onFind(selectors.base, function (element) {
        on('click', function(e) {
            let tabToActivate = e.target.dataset.activateTabId || false;

            if(tabToActivate) {
                let nav = find(selectors.nav);
                let triggerEl = findIn(`[href='${tabToActivate}']`, nav);
                Tab.getInstance(triggerEl).show()
            }

        }, element);
    });
}